import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AllJobs from "../components/AllJobs";

const AllJobsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='All Jobs' />

                <AllJobs />

            </MasterLayout>
        </>
    );
};

export default AllJobsPage;
